import { render, staticRenderFns } from "./modal-slide-root.vue?vue&type=template&id=63c16dea"
import script from "./modal-slide-root.vue?vue&type=script&lang=ts"
export * from "./modal-slide-root.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports